import React from 'react';
import { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { 
    handle_forgotPassword 
} from '../../Redux/reducer';
import { 
    resetPasswordFunc 
} from '../../Redux/actions';

const ForgotPassword = () => {
    
    //Reference
    const emailRef = useRef();
    //Redux
    const dispatch = useDispatch();

    const handleForgetPasswordSubmit = (e) => {
    e.preventDefault();
      dispatch(resetPasswordFunc(emailRef.current.value));
    };

    const enterPressedForgetPassword = (event) => {
        var code = event.keyCode || event.which;
        if (code === 13) {
            handleForgetPasswordSubmit(event);
            //13 is the enter keycode
            //Do stuff in here
        }
    };

    return(
        <div className="login-input-container">
            <div className='home-contact-join-form-title'>
                Reset Password
              </div>
        <form
          onSubmit={handleForgetPasswordSubmit}
           onKeyPress={(e) => enterPressedForgetPassword(e)}
        >
          <input
            style={{ margin: "30px 0px 30px 0px" }}
            placeholder="Recovery Email"
            className="email-ip"
            type="text"
            required
            ref={emailRef}
          />
          <div className="btnContainer">
              <a className='home-contact-signup-link' 
                onClick={()=>dispatch(handle_forgotPassword(false))}
            > Go back </a> 
            <button className='home-contact-join-submit-btn' type={"submit"}>Submit</button>
          </div>
        </form>
        
      </div>
    )
}

export default ForgotPassword;